import PropTypes from 'prop-types';
import React from 'react';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import ReadonlyField from '../ReadonlyField';
import DateTimeField from '../DateTimeField';
import DateTime, { DATETIME } from '../../DateTime';
import { resolveValue } from '../../../utils/fields';
import { extendedStateType } from '../../../types';
import { NO_STATE } from '../../../hooks/useExtendedState';

PrivilegedDateTimeField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    state: extendedStateType,
};

PrivilegedDateTimeField.defaultProps = {
    sufficientReadPrivileges: null,
    value: undefined,
    state: NO_STATE,
};

function PrivilegedDateTimeField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        value,
        state,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const resolvedValue = resolveValue(value, state);
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    let result = null;
    if (canWrite) {
        result = (
            <DateTimeField
                value={value}
                state={state}
                {...rest}
            />
        );
    } else if (canRead) {
        result = (
            <ReadonlyField
                value={
                    <DateTime value={resolvedValue ? resolvedValue.toString() : ''} format={DATETIME} />
                }
                state={state}
                {...rest}
            />
        );
    }
    return result;
}

export default PrivilegedDateTimeField;
